import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A4D7F] text-white mt-20" data-testid="main-footer">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">A-ONE VISAS</h3>
            <p className="text-blue-100 text-sm leading-relaxed">
              {t.footer.description}
            </p>
          </div>
          
          <div>
            <h4 className="font-heading font-semibold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-blue-100 hover:text-white transition-colors text-sm">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/apply" className="text-blue-100 hover:text-white transition-colors text-sm">
                  {t.nav.applyForVisa}
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-blue-100 hover:text-white transition-colors text-sm">
                  {t.nav.trackApplication}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-heading font-semibold mb-4">{t.footer.contactUs}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-blue-100 text-sm">
                <Mail className="w-4 h-4" />
                <a href="mailto:customer-support@aonevisas.com" className="hover:text-white transition-colors">
                  customer-support@aonevisas.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-blue-100 text-sm">
                <Phone className="w-4 h-4" />
                <a href="tel:+971503312723" className="hover:text-white transition-colors">+971 50 331 2723</a>
              </li>
              <li className="flex items-center gap-2 text-blue-100 text-sm">
                <MapPin className="w-4 h-4" />
                <span>Dubai, UAE</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-blue-600 mt-8 pt-6 text-center text-blue-100 text-sm">
          <p>&copy; {new Date().getFullYear()} A-One Visas. {t.footer.allRights}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;